import { render, staticRenderFns } from "./InsuranceClaimReport.vue?vue&type=template&id=f6ad4b82"
import script from "./InsuranceClaimReport.vue?vue&type=script&lang=js"
export * from "./InsuranceClaimReport.vue?vue&type=script&lang=js"
import style0 from "./InsuranceClaimReport.vue?vue&type=style&index=0&id=f6ad4b82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports